// Using this as a node for tournament brackets

import moment from 'moment';
import { Handle, Position } from '@xyflow/react';
import placeholderTeam from '../assets/images/placeholder-team.png';
import './BracketsNode.scss';

export default function BracketsNode({ data }) {
  const {
    bye,
    free,
    byeTeamName,
    byeTeamImg,
    byeTeamId,
    byeTeamCoaches,
    gameId,
    gameDate,
    date,
    time,
    field,
    team1,
    team2,
    team1Id,
    team2Id,
    team1Img,
    team2Img,
    team1Coaches,
    team2Coaches,
    score1,
    score2,
    referees,
    placement,
    highlight,
    pickMode,
    onClick,
    activeHoverKey,
    onHoverChange,
    onWatchInSchedule,
  } = data || {};

  const hoverTrigger = (value, hoverKey) => {
    if (!hoverKey) return value;
    return (
      <span
        className={
          'hover-trigger' + (activeHoverKey === hoverKey ? ' active' : '')
        }
        onMouseEnter={() => onHoverChange(hoverKey)}
        onMouseLeave={() => onHoverChange(null)}
      >
        {value}
      </span>
    );
  };

  const handles = (
    <>
      <Handle
        type='target'
        position={Position.Left}
        id='left-input'
        style={{ visibility: 'hidden' }}
      />
      <Handle
        type='target'
        position={Position.Right}
        id='right-input'
        style={{ visibility: 'hidden' }}
      />
      <Handle
        type='source'
        position={Position.Left}
        id='left-output'
        style={{ visibility: 'hidden' }}
      />
      <Handle
        type='source'
        position={Position.Right}
        id='right-output'
        style={{ visibility: 'hidden' }}
      />
    </>
  );

  if (free) {
    return (
      <div
        className={
          'brackets-node free' +
          (highlight ? ' highlighted' : '') +
          (pickMode ? ' pick' : '')
        }
        onClick={onClick}
      >
        {handles}
        <p className='free-label'>Isn't scheduled</p>
        <p className='placement'>{'#' + (placement + 1)}</p>
      </div>
    );
  }

  if (bye) {
    return (
      <div className='brackets-node bye'>
        {handles}
        <div className='teams-score-wrap'>
          <div className='team'>
            <div className='team-emblem-row'>
              {byeTeamName && (
                <div
                  className='bg-image wh-32'
                  style={{
                    backgroundImage: `url(${byeTeamImg || placeholderTeam})`,
                  }}
                />
              )}
              <div className='wrap'>
                <p className='font-medium'>
                  {hoverTrigger(
                    byeTeamName || 'TBD',
                    byeTeamId && `team:${byeTeamId}`,
                  )}
                </p>
                {byeTeamCoaches?.map((coach) => (
                  <p key={coach.id}>
                    {hoverTrigger(coach.name, `coach:${coach.id}`)}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <p className='font-medium score'> - </p>
          <div className='team'>
            <div className='team-emblem-row'>
              <div className='wrap'>
                <p className='font-medium'>BYE</p>
              </div>
            </div>
          </div>
        </div>
        <p className='placement'>{'#' + (placement + 1)}</p>
      </div>
    );
  }

  return (
    <div
      className={'brackets-node' + (highlight ? ' highlighted' : '')}
      onClick={onClick}
    >
      {handles}
      {date && (
        <>
          <p>{`${moment(date).format('MMM D, YYYY')}`}</p>
          {onWatchInSchedule ? (
            <button
              className='watch-in-schedule transparent small'
              onClick={(e) => {
                e.stopPropagation();
                onWatchInSchedule(gameId, gameDate);
              }}
            >
              {time}, {field}
            </button>
          ) : (
            <p>
              {time}, {field}
            </p>
          )}
          <div className='teams-score-wrap'>
            <div className='team'>
              <div className='team-emblem-row'>
                {team1 && (
                  <div
                    className='bg-image wh-32'
                    style={{
                      backgroundImage: `url(${team1Img || placeholderTeam})`,
                    }}
                  />
                )}
                <div className='wrap'>
                  <p className='font-medium'>
                    {hoverTrigger(team1 || 'TBD', team1Id && `team:${team1Id}`)}
                  </p>
                  {team1Coaches?.map((coach) => (
                    <p key={coach.id}>
                      {hoverTrigger(coach.name, `coach:${coach.id}`)}
                    </p>
                  ))}
                </div>
              </div>
            </div>
            <p className='font-medium score'>
              {score1 !== null || score2 !== null
                ? score1 + ' : ' + score2
                : ' - '}
            </p>
            <div className='team'>
              <div className='team-emblem-row'>
                {team2 && (
                  <div
                    className='bg-image wh-32'
                    style={{
                      backgroundImage: `url(${team2Img || placeholderTeam})`,
                    }}
                  />
                )}
                <div className='wrap'>
                  <p className='font-medium'>
                    {hoverTrigger(team2 || 'TBD', team2Id && `team:${team2Id}`)}
                  </p>
                  {team2Coaches?.map((coach) => (
                    <p key={coach.id}>
                      {hoverTrigger(coach.name, `coach:${coach.id}`)}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <p className='referees'>
            Referees:{' '}
            {referees
              .map((referee) => (
                <span key={referee.id}>
                  {hoverTrigger(
                    referee.name?.replace(/ /g, '\u00A0'),
                    `ref:${referee.id}`,
                  )}
                </span>
              ))
              .reduce(
                (prev, curr, i) => (i === 0 ? [curr] : [...prev, ', ', curr]),
                [],
              )}
          </p>
        </>
      )}
      {!date && <p>Isn't scheduled</p>}
      <p className='placement'>{'#' + (placement + 1)}</p>
    </div>
  );
}
